const CALIBRATION_DATA_FETCHING = 'CALIBRATION_DATA_FETCHING';
const CALIBRATION_DATA_FETCHED = 'CALIBRATION_DATA_FETCHED';
const CALIBRATION_DATA_FETCHING_FAILED = 'CALIBRATION_DATA_FETCHING_FAILED';
const CALIBRATION_DATA_STATE_ADD="CALIBRATION_DATA_STATE_ADD";
const CALIBRATION_DATA_STATE_REMOVE="CALIBRATION_DATA_STATE_REMOVE";
const CALIBRATION_LOT_DATA = 'CALIBRATION_LOT_DATA';
const CALIBRATION_CONFIG_FETCHING = 'CALIBRATION_CONFIG_FETCHING';
const CALIBRATION_CONFIG_FETCHED = 'CALIBRATION_CONFIG_FETCHED';
const CALIBRATION_CONFIG_FAILED = 'CALIBRATION_CONFIG_FAILED';

export {
    CALIBRATION_DATA_FETCHING,
    CALIBRATION_DATA_FETCHED,
    CALIBRATION_DATA_FETCHING_FAILED,
    CALIBRATION_DATA_STATE_ADD,
    CALIBRATION_DATA_STATE_REMOVE,
    CALIBRATION_LOT_DATA,
    CALIBRATION_CONFIG_FETCHING,
    CALIBRATION_CONFIG_FETCHED,
    CALIBRATION_CONFIG_FAILED
}